import { motion } from 'framer-motion'
import type { SlideProps } from '@/components/SlideWizard'
import { useSlideCopy } from '@/lib/i18n'
import { copy } from './Slide13LittleTraining.copy'

const ease = [0.16, 1, 0.3, 1] as const

export default function Slide13LittleTraining(_props: SlideProps) {
  const c = useSlideCopy(copy)

  return (
    <div className="min-h-[50vh] flex flex-col items-center justify-center text-center px-4 mx-auto max-w-3xl">
      <motion.h2
        initial={{ opacity: 0, y: 14 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.6, delay: 0.1, ease }}
        className="text-3xl sm:text-5xl font-semibold text-slate-900 tracking-tight leading-[1.1]"
      >
        {c.title}
      </motion.h2>
      <motion.p
        initial={{ opacity: 0, y: 14 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.6, delay: 0.4, ease }}
        className="mt-8 text-xl sm:text-2xl text-slate-500 leading-relaxed"
      >
        {c.body}
      </motion.p>
    </div>
  )
}
